import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import type { FC, MouseEvent, ReactNode } from "react";
import AsyncLoadingButton from "../asyncLoadingButton/AsyncLoadingButton";

interface Props {
  readonly open: boolean;
  readonly title: string;
  readonly content: ReactNode;
  readonly confirmButtonText?: string;
  readonly onConfirm: ((e: MouseEvent) => Promise<void>) | undefined;
  readonly onCancel: () => void;
}

const ConfirmationDialog: FC<Props> = ({ open, title, content, confirmButtonText, onConfirm, onCancel }) => {
  return (
    <Dialog open={open}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography>{content}</Typography>
      </DialogContent>
      <DialogActions>
        <Button color="secondary" autoFocus onClick={onCancel}>
          Anuluj
        </Button>
        <AsyncLoadingButton onClick={onConfirm}>{confirmButtonText ?? "Potwierdź"}</AsyncLoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
